import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { map } from 'lodash'
import { useState } from 'react'
import { FileUploader } from 'react-drag-drop-files'
import ArrowDownIcon from '../../../../assets/icons/ArrowDown.svg?react'
import DeviceIcon from '../../../../assets/icons/Device.svg'
import DiskIcon from '../../../../assets/icons/Disk.svg'
import { StorageChoiceFilesDialog } from '../../../../dialogs/StorageChoiceFilesDialog'
import { useDocumentDragState } from '../../../../hooks/useDocumentDragState'
import { useRequestsStore } from '../../../../store/storeRequests'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { validateFiles } from './filesInRequest'

export const FilesMenu = ({ handleChangeFiles, fileTypes, isDisabled }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const { filesByStorage } = useRequestsStore((state) => state)
    const { modelDetail } = useWrapperStore((state) => state)
    const {
        setFilesInRequest,
        files,
        setFile,
        setFilesError,
    } = useRequestsStore((state) => state)
    const [isOpenStorageChoiceFilesDialog, setIsOpenStorageChoiceFilesDialog] = useState(false)
    const { isDragging, onDrop } = useDocumentDragState()
    const open = Boolean(anchorEl)
    const classes = isDragging
        ? 'upload-request-file upload-request-file--dragging'
        : 'upload-request-file'

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleClickChangeFiles = (files) => {
        handleClose()
        handleChangeFiles(files)
    }

    const handleAddFiles = () => {
        document.getElementById('upload-request-file')?.click()
    }

    const handleTypeError = () => {
        onDrop()
        setFilesError(['Данные типы файлов не поддерживаются ARHIASSISTANT'])
    }

    const handleSizeError = () => {
        onDrop()
        setFilesError(['Слишком большой размер добавляемых файлов'])
    }

    const handleDraggingStateChange = (dragging: boolean) => {
        if (!dragging) {
            onDrop()
        }
    }

    const handleOpenStorageChoiceFilesDialog = () => {
        setIsOpenStorageChoiceFilesDialog(true)
    }

    const handleCloseStorageChoiceFilesDialog = () => {
        setIsOpenStorageChoiceFilesDialog(false)
    }
    const handleSubmitStorageChoiceFilesDialog = () => {
        setFilesError(null)
        const draftFiles = files ?? []

        map(filesByStorage, (file, index) => {
            file['name'] = file.filename
            file['file_size'] = file.size
            file['isLoaded'] = true
        })

        const validationResult = validateFiles(
            [...draftFiles, ...filesByStorage],
            modelDetail?.supported_content,
        )

        setFilesInRequest(undefined)
        setFile(validationResult.fileValidations)
        setFilesError(validationResult.isValid ? null : validationResult.errors)
        setIsOpenStorageChoiceFilesDialog(false)
    }

    return (
        <>
            <FileUploader
                multiple={true}
                types={fileTypes}
                classes={classes}
                name="upload-request-file"
                dropMessageStyle={{ display: 'none' }}
                handleChange={handleClickChangeFiles}
                onDrop={onDrop}
                onTypeError={handleTypeError}
                onSizeError={handleSizeError}
                onDraggingStateChange={handleDraggingStateChange}>
                <Box display="flex" alignItems="center" gap={1}>
                    <ArrowDownIcon />
                    <Typography
                        variant="caption"
                        color="textPrimary"
                        fontWeight={500}
                        textAlign="center">
                        Перетяните файл в эту область
                    </Typography>
                </Box>
            </FileUploader>
            <Tooltip title="Прикрепите или перетяните файл в поле запроса">
                <IconButton
                    disabled={isDisabled}
                    onClick={handleClick}
                    size="small"
                    sx={{
                        width: '40px',
                        height: '40px',
                        border: '1px solid #E5E5E7',
                        '&:hover': {
                            background: '#F6F6F6',
                            border: '1px solid #E5E5E7',
                        },
                    }}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}>
                    <AttachFileOutlinedIcon />
                </IconButton>
            </Tooltip>
            <Menu
                sx={{ width: '360px' }}
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: {
                        elevation: 0,
                    },
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'top' }}>
                <MenuItem onClick={handleOpenStorageChoiceFilesDialog}>
                    <ListItemIcon sx={{ justifyContent: 'center' }}>
                        <DiskIcon />
                    </ListItemIcon>
                    <Typography>Загрузить с "Мой диск"</Typography>
                </MenuItem>
                <MenuItem onClick={handleAddFiles}>
                    <ListItemIcon sx={{ justifyContent: 'center' }}>
                        <DeviceIcon />
                    </ListItemIcon>
                    <Typography>Загрузить с устройства</Typography>
                </MenuItem>
            </Menu>
            {isOpenStorageChoiceFilesDialog && (
                <StorageChoiceFilesDialog
                    open={isOpenStorageChoiceFilesDialog}
                    handleClose={handleCloseStorageChoiceFilesDialog}
                    handleSubmit={handleSubmitStorageChoiceFilesDialog}
                />
            )}
        </>
    )
}
